import styled from "styled-components";

export const HeaderContainer = styled.div`
  background-color: #ffffff;
  box-shadow: 0 8px 8px -6px rgba(0, 0, 0, 0.5);
  /* reponsive */
  .circular-image {
    border-radius: 50%;
    object-fit: cover; 
    border: 2px solid #ccc; 
    overflow: hidden;
  }
  .mobile-logo {
    width: 60%;
    display: block;
    margin: auto;
  }
  .NavActive {
    border-bottom: 4px solid #0971a2;
  }
  .right-menu-item {
    font-weight: bold;
    font-size: 0.875rem;
    color: #333333;
  }

  .relative-avatar {
    margin: auto;
  }
  .profile-dropdown-menu {
    bottom: -320px;
  }

  #user-name {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 18.75px;
    padding: 22px 0;
  }

  .menu-item-option {
    font-size: 16px;
    font-weight: 400;
    color: #000000;
    line-height: 18.75px;
    padding: 20px;
  }
  .menu-item-option:hover {
	color: #ffffff;
	background-color: #0971a2;
  }

  #role {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 18.75px;
    padding: 22px 0;
  }

  .profile-avatar{
        position: relative;
    }

    .inquiries-count{
        width: 16px;
        height: 16px;
        background-color: #03A100;
        bottom: 0;
        position: absolute;
        right: 0;
        p {
            padding-top: 1px;
        }
    }

    .inquiries-count-plus{
        width: 24px;
        height: 16px;
        background-color: #03A100;
        bottom: 0;
        position: absolute;
        right: 0;
        p {
            padding-top: 1px;
        }
    }

    .inquiries-count-dropdown{
        width: 16px;
        height: 16px;
        background-color: #03A100;
        margin-left: 20px;
        margin: auto 0;
        margin-left: 20px;
        p {
            /* margin-top: 1px; */
        }
    }

    .inquiries-count-dropdown-plus{
        width: 24px;
        height: 16px;
        background-color: #03A100;
        margin-left: 20px;
        margin: auto 0;
        margin-left: 20px;
        p {
            /* margin-top: 1px; */
        }
    }

  @media only screen and (min-width: 1512px) {
    .navbar {
      max-width: 1142px;
      width: 90%;
      margin: 0 auto;
    }
    .navbar-desktop {
      display: flex;
      width: 100%;
    }
    .mobile-menu {
      display: none;
    }

    .logo {
      margin: auto 0;
    }
    .logo-space {
      width: 1142px;
    }
    .container {
      width: 100%;
      padding: 0px 45px;
    }
    .top-header {
      padding: 0px 100px;
      display: flex;
      width: 100%;
      height: 70px;
      max-width: 1512px;
      justify-content: center;
      margin: 0 auto;
    }

    .back-to-ag {
      text-align: right;
      margin: auto auto;
    }

    .back-to-ag a {
      margin: auto auto;
      text-decoration: underline;
      font-size: 0.9375rem;
      font-weight: bold;
      color: #58585b;
    }
    .line {
      border-top: 1px solid rgb(242 243 245); /* Define the line */
    }

    .navbar ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
    }

    .navbar ul li {
      display: inline;
    }

    #Commerce-item {
      font-weight: bold;
      color: rgb(88 88 91);
    }

    /* menu */

    .navbar {
      background-color: #ffffff;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .left-menu {
      height: auto;
      padding: 10px 0px;
    }

    .left-menu ul,
    .right-menu ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      height: auto;
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }

    .right-menu {
      text-align: right;
      margin: auto 0;
      margin-bottom: 0px;
    }

    .left-menu-item,
    .right-menu-item {
      display: inline-block;
      margin: 0px 10px;
      padding: 20px 0px;
      color: #333333;
    }
    /* hover */
    .left-menu-item:hover,
    .right-menu-item:hover {
      border-bottom: 4px solid #0971a2;
      border-radius: 0.5px;
      cursor: pointer;
    }

    /* .profile-menu ul li:hover,
    .profile-menu ul li:hover span {
      padding-left: 20px;
      color: #000000;
      font-weight: 400;
      line-height: 18.75px;
    } */
  }
  @media only screen and (min-width: 1025px) and (max-width: 1511px) {
    .navbar {
      max-width: 1142px;
      width: 90%;
      margin: 0 auto;
    }
    .navbar-desktop {
      display: flex;
      width: 100%;
    }
    .mobile-menu {
      display: none;
    }

    .logo {
      margin: auto 0;
    }

    .container {
      width: 100%;
      padding: 0px 45px;
    }
    .top-header {
      padding: 0px 60px;
      display: inline-flex;
      width: 100%;
      height: 70px;
    }

    .back-to-ag {
      text-align: right;
      margin: auto auto;
    }

    .back-to-ag a {
      margin: auto auto;
      text-decoration: underline;
      font-size: 0.9375rem;
      font-weight: bold;
      color: #58585b;
    }
    .line {
      border-top: 1px solid rgb(242 243 245); /* Define the line */
    }

    .navbar ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
    }

    .navbar ul li {
      display: inline;
      color: #58585b;
    }

    #Commerce-item {
      font-weight: bold;
      color: rgb(88 88 91);
    }

    /* menu */

    .navbar {
      background-color: #ffffff;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .left-menu {
      height: auto;
      padding: 10px 0px;
    }

    .left-menu ul,
    .right-menu ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      height: auto;
      display: flex;
      justify-content: flex-end;
    }

    .right-menu {
      text-align: right;
      margin: auto 0;
      margin-bottom: 0px;
    }

    .left-menu-item,
    .right-menu-item {
      display: inline-block;
      margin: 0px 10px;
      padding: 20px 0px;
    }

    /* hover */
    .left-menu-item:hover,
    .right-menu-item:hover {
      border-bottom: 4px solid #0971a2;
      border-radius: 0.5px;
      cursor: pointer;
    }
  }
  @media only screen and (min-width: 769px) and (max-width: 1024px) {
    .mobile-menu {
      display: none;
    }
    .left-menu-item {
      font-size: 14px;
    }

    .top-header {
      padding: 0px 20px;
      display: flex;
      width: 100%;
      height: 60px;
    }

    .back-to-ag {
      text-align: right;
      margin: auto auto;
    }

    .back-to-ag a {
      display: inline-block; /* Ensure the link behaves as a block element */
      text-decoration: underline;
      font-size: 0.9375rem;
      font-weight: bold;
      color: #58585b;
    }

    .line {
      border-top: 1px solid rgb(242 243 245); /* Define the line */
    }

    .navbar ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
    }
    .logo {
      margin: auto 0;
    }
    .navbar ul li {
      display: inline;
      color: #58585b;
    }

    #Commerce-item {
      font-weight: bold;
      color: rgb(88 88 91);
    }

    /* menu */
    .navbar {
      max-width: 1142px;
      width: 90%;
      margin: 0 auto;
    }

    .navbar-desktop {
      background-color: #ffffff;
      align-items: center;
      display: flex;
      width: 100%;
    }

    .left-menu {
      height: auto;
      padding: 10px 0px;
    }

    .left-menu ul,
    .right-menu ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      height: auto;
      display: flex;
      justify-content: flex-end;
    }

    .right-menu {
      text-align: right;
      margin: auto 0;
      margin-bottom: 0px;
    }

    .left-menu-item,
    .right-menu-item {
      display: inline-block;
      margin: 0px 10px;
      padding: 20px 0px;
    }

    /* hover */
    .left-menu-item:hover {
      border-bottom: 2px solid rgb(250 0 27);
      border-radius: 0.5px;
      cursor: pointer;
    }
  }
  @media only screen and (min-width: 641px) and (max-width: 768px) {
    .container {
      width: 100% !important;
    }
    .menu-container {
      padding: 40px 0px;
      max-width: 768px;
      position: relative;
    }
    /* disable */
    .navbar-desktop,
    .back-to-ag,
    .profile-menu,
    .top-header,
    .logo,
    .line {
      display: none;
    }

    .mobile-menu-header {
      display: inline-flex;
      width: 100%;
    }

    .mobile-logo {
      width: 100%;
    }

    .mobile-menu img {
      margin: 0 auto;
    }

    /* menu-mobile */

    .menu-toggle {
      background: none;
      border: none;
      cursor: pointer;
      padding: 10px 10px 10px 20px;
      font-size: 1.125rem;
    }

    .menu-list {
      position: fixed;
      bottom: 0;
      left: 0px;
      top: 65px;
      width: 100%;
      height: 100%;
      background-color: rgb(24, 153, 214);
      border: 1px solid rgb(204, 204, 204);
      border-radius: 5px;
      padding: 100px 30px;
      z-index: 1;
      height: calc(100dvh - 84px);
    }

    .menu-list li {
      list-style: none;
      margin: 5px 0;
      color: #ffffff;
      font-size: 1.5rem;
    }

    .menu-list img {
      margin: 5px 0;
      color: #ffffff;
    }

    .menu-list li:hover {
      background-color: rgba(136, 201, 231, 1);
    }

    .close-button {
      position: absolute;
      right: 26px;
      top: 120px;
      background: none;
      border: none;
      cursor: pointer;
      z-index: 2;
    }

    /* Style the close button image as needed */
    .close-button img {
      width: 80%;
      height: auto;
    }
  }
  @media only screen and (max-width: 640px) {
    .menu-container {
      padding: 40px 0px;
      width: 100% !important;
      position: relative;
    }
    /* disable */
    .navbar,
    .back-to-ag,
    .top-header,
    .logo,
    .line {
      display: none;
    }

    .mobile-menu-header {
      width: 100%;
      display: inline-flex;
    }

    .mobile-logo {
      width: 100%;
    }

    .mobile-menu img {
      margin: 0 auto;
    }

    /* menu-mobile */
    .mobile-menu {
      position: relative;
    }

    .menu-toggle {
      background: none;
      border: none;
      cursor: pointer;
      padding: 10px 10px 10px 20px;
      font-size: 1.125rem;
    }

    .menu-list {
      position: fixed;
      bottom: 0;
      left: 0px;
      top: 65px;
      width: 100%;
      height: 100%;
      background-color: rgb(24, 153, 214);
      border: 1px solid rgb(204, 204, 204);
      border-radius: 5px;
      padding: 100px 30px;
      z-index: 1;
      height: calc(100dvh - 84px);
    }

    .menu-list li {
      list-style: none;
      margin: 5px 0;
      color: #ffffff;
      font-size: 1.5rem;
    }

    .menu-list img {
      margin: 5px 0;
      color: #ffffff;
    }

    .menu-list li:hover {
      background-color: rgba(136, 201, 231, 1);
    }

    .close-button {
      position: absolute;
      right: 26px;
      top: 120px;
      background: none;
      border: none;
      cursor: pointer;
      z-index: 2;
    }

    /* Style the close button image as needed */
    .close-button img {
      width: 80%;
      height: auto;
    }
  }
`;

export const Div = styled.div``;
